import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Concentric ink-blot — a filled inner dot, a hairline middle ring, and
 *  a wider outermost ring that ripples outward at low opacity. Reads like
 *  ink dropping onto paper; a calm, looping ambient mark. */
export function IcnInkBlot(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const reduced = useReducedMotion();
  return (
    <Svg {...rest} iconName="ink-blot" data-on={active ? 'true' : 'false'}>
      {/* Outer ripple — fades from solid → invisible while expanding. */}
      <circle cx="8" cy="8" r="3" opacity="0">
        {!reduced && active && (
          <>
            <animate
              attributeName="r"
              values="3;6.6"
              dur="3.4s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.55;0"
              dur="3.4s"
              repeatCount="indefinite"
            />
          </>
        )}
      </circle>
      {/* Hairline middle ring */}
      <circle cx="8" cy="8" r="3.4" opacity="0.45" />
      {/* Solid central blot */}
      <circle cx="8" cy="8" r="1.6" fill="currentColor" stroke="none" />
    </Svg>
  );
}
